import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import userStorage from "store/UserStorage";
import { batch } from "react-redux";
import { setResponseMessage } from "../adminSlice";
import { setMessage } from "features/message/messageSlice";
import { MessageType } from "features/message/types";

const initialState = {
  loading: false,
};

const emailSenderAdmin = createSlice({
  name: "emailSenderAdminSlice",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});
export const { setLoading } = emailSenderAdmin.actions;

export const selectLoading = (state: RootState) =>
  state.emailSenderAdmin.loading;

export const sendEmailToAll =
  (content: any, onUploadProgress: (e: ProgressEvent<EventTarget>) => void) =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const json = JSON.stringify({ ...content });
      let token = userStorage.getUser();
      const response = await axios.post(
        `${API_URL}/admin/email-notification`,
        { data: json },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          onUploadProgress,
        }
      );
      console.log(json);
      batch(() => {
        dispatch(setResponseMessage({ message: "Изпратено", hasError: false }));
        dispatch(setLoading(false));
      });
    } catch (error: any) {
      batch(() => {
        dispatch(
          setResponseMessage({ message: error.message, hasError: true })
        );
        dispatch(setLoading(false));
      });

      //  console.log(`Error in addTag: ${error.message}`);
    }
  };

export const contactUs = (content: any) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify({ ...content });
    const response = await axios.post(
      `${API_URL}/contact-form`,
      { data: json },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch(
      setMessage({
        text: `Съобщението Ви е изпратено.`,
        type: MessageType.success,
      })
    );
  } catch (error: any) {
    dispatch(
      setMessage({
        text: `Възника грешка, моля да ни извините. Моля опитайте отново.`,
        type: MessageType.danger,
      })
    );

    //  console.log(`Error in addTag: ${error.message}`);
  }
};

export const subscribe = (content: any) => async (dispatch: any) => {
  try {
    const json = JSON.stringify({ ...content });
    const response = await axios.post(
      `${API_URL}/admin/email`,
      { data: json },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch(
      setMessage({
        text: `Успешно се абонинрахте за нашия бюлетин.`,
        type: MessageType.info,
      })
    );
  } catch (error: any) {
    dispatch(
      setMessage({
        text: `Възника грешка, моля да ни извините. Моля опитайте отново.`,
        type: MessageType.danger,
      })
    );
  }
};

export const unsubscribe = (email: string) => async (dispatch: any) => {
  try {
    const response = await axios.delete(`${API_URL}/admin/email/${email}`);
    dispatch(
      setMessage({
        text: `Успешно се отписахте от нашия бюлетин.`,
        type: MessageType.info,
      })
    );
  } catch (error: any) {
    dispatch(
      setMessage({
        text: `Възника грешка, моля да ни извините. Моля опитайте отново.`,
        type: MessageType.danger,
      })
    );
  }
};

export default emailSenderAdmin.reducer;
